module.exports = __webpack_public_path__ + "img/check-phone-msg.55a4f335.svg";